export default function TpRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 810px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>
            <div class="modal fade show" id="modalMarketRules" tabindex="-1" style={{ display: "block" }}>
                <div className=" modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>

                                <div>
                                    <center>
                                        <h1><b>Teenpatti T20</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20"> Bet stands on the individual player, Independent of other player's hands. If the same player holds any of the below hand would yield the following payout, else customer loses the bet. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Hands</th>
                                                                <th>Payout</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th>PAIR</th>
                                                                <th>1:1</th>
                                                            </tr>
                                                            <tr>
                                                                <th>FLUSH</th>
                                                                <th>1:4</th>
                                                            </tr>
                                                            <tr>
                                                                <th>STRAIGHT</th>
                                                                <th>1:6</th>
                                                            </tr>
                                                            <tr>
                                                                <th>STRAIGHT FLUSH</th>
                                                                <th>1:25</th>
                                                            </tr>
                                                            <tr>
                                                                <th>TRIO</th>
                                                                <th>1:35</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <p class="pt20">In the event of a tie, bets on Player A and Player B are refunded.</p>
                                                </div>
                                            </div>

                                        </div>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20"> In this version of Teenpatti, a total of six cards are put on the table one by one by the dealer. User can place bet(s) only before the round starts. The player with the better hand wins. </p>
                                        </div>
                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"> The game is played with a single 52-card deck (excluding Jokers), cards are shuffled after each game round. Any number of players can participate in a single game simultaneously. </p>
                                            <div>
                                                <h3>Ranking of the hands</h3>
                                                <p class="pt20"> Aces are ranked the highest and 2's are the lowest. The objective of the game is to have the best 3-card hand and to maximise the pot before the showdown. The categories are ranked as follows (from high to low): </p>
                                                <div>
                                                    <p class="pt20"><b>(1)Trail (three of a kind):</b> Three cards of the same rank. Three aces are the highest and three 2's are the lowest.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r1.jpg" />
                                                    </div>
                                                    <p class="pt20"><b>(2) Pure Sequence (Straight Flush):</b> Three consecutive cards of the same suit.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r2.jpg" />
                                                    </div>
                                                    <p class="pt20"><b>(3) Sequence (Straight):</b> Three consecutive cards not all in the same suit.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r3.jpg" />
                                                    </div>
                                                    <p class="pt20"><b>(4) Color (Flush):</b> Three cards of the same suit that are not in sequence. When comparing two colors, first compare the highest card. If these are equal, compare the second and if these are equal compare the lowest. Highest flush is A-K-J and the lowest flush is 5-3-2.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r4.jpg" />
                                                    </div>
                                                    <p class="pt20"><b>(5) Pair (two of a kind):</b>  Two cards of the same rank. Between two pairs, the one with the higher value is the winner. If the pairs are of equal value then the kicker card determines the winner. The highest pair is A-A-K and the lowest is 2-2-3.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r5.jpg" />
                                                    </div>
                                                    <p class="pt20"> <b>(6) High Card:</b> A hand in which the three cards are not in sequence, not all the same suit and no two cards have the same rank. If two players share a common high card, the next highest card is used to determine the winner. The best high card hand would be an AKJ of different suits and the worst is 5-3-2.</p>
                                                    <div>
                                                        <img class="imgt20" alt="teenpatti_test" src="/assets/images/9001r6.jpg" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                    <div>
                                        <center><h3>Betting Instructions</h3></center>
                                        <ul>
                                            <li class="lit20">If a game round is in progress when you enter the game, please wait for the next one, and then, place your bets. </li>
                                            <li class="lit20">After the timer reaches 0, the game round begins.</li>
                                            <li class="lit20">To place a bet, click on the box, enter the stake amount and submit by clicking on Place Bet button.</li>
                                            <li class="lit20">You can place several bets on different runners in different markets simultaneously.</li>
                                            <li class="lit20">The timer shows how much time you have left to place your bets.</li>
                                            <li class="lit20">Winnings are paid for the winning bets at the end of each game round.</li>
                                            <li class="lit20">To skip a turn, simply do not place any bets.</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <center><h3>Main Bets</h3></center>
                                        <ol>
                                            <li class="lit20">1. PLAYER A</li>
                                            <li class="lit20">2. PLAYER B</li>
                                        </ol>
                                    </div>
                                    <div>
                                        <center><h3>Side Bets</h3></center>
                                        <p class="pt20">The player can also place a bet on one of the following side bets:</p>
                                        <ul>
                                            <li class="lit20">Player A+ - Predict if player A will get a pair or better</li>
                                            <li class="lit20">Player B+ - Predict if player B will get a pair or better</li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}